export const faqItems = [
  {
    question: '亚洲精品一区二区是什么？',
    answer: '亚洲精品一区二区是一个专注于亚洲精品内容聚合与分区导览的平台。我们通过一区精品推荐和二区优质资源两大核心板块，为用户提供精准分类、快速定位的内容发现服务。一区侧重精品推荐与深度内容，二区聚焦优质资源与特色专栏，共同满足您对亚洲精品内容的多样化需求。',
  },
  {
    question: '一区和二区的内容有什么区别？',
    answer: '一区精品推荐主要涵盖编辑精选、热门推荐、深度好文和专题策划类内容，侧重于内容的品质把控和专业编辑筛选；二区优质资源则聚焦于资源聚合、精品合集、热门资源和特色专栏，更加注重资源的全面性和多样性。两个分区各有侧重，互为补充。',
  },
  {
    question: '如何快速找到我感兴趣的内容？',
    answer: '您可以通过以下方式快速定位感兴趣的内容：1) 使用首页的分类导航卡片进入对应分区；2) 在分类页面通过子分类标签进行精准筛选；3) 利用搜索功能输入关键词查找；4) 浏览首页的精选推荐和最新内容板块发现优质内容。',
  },
  {
    question: '平台上的内容多久更新一次？',
    answer: '平台内容保持每日更新，编辑团队会持续筛选和发布最新精品内容。"最新上线"板块实时展示今日更新内容，确保您第一时间获取新鲜资源。此外，每周和每月还会发布综合排行榜单，帮助您发现最受欢迎的内容。',
  },
  {
    question: '如何区分编辑精选和普通内容？',
    answer: '编辑精选内容会在标题旁显示"精选"标识，这些内容经过编辑团队从原创性、信息准确性、表达质量、视觉呈现、用户价值和时效性六个维度严格评审，总分达到90分以上才能获得此标识。普通内容则没有该标识，但不代表质量不高。',
  },
  {
    question: '可以收藏或保存喜欢的内容吗？',
    answer: '目前平台支持通过浏览器书签功能保存喜欢的内容页面。我们正在开发用户账号系统，未来将支持在线收藏、历史记录和个性化推荐等更多功能，为您提供更好的内容管理体验。',
  },
  {
    question: '平台内容是否收费？',
    answer: '亚洲精品一区二区平台上的所有内容目前均为免费浏览，我们致力于为所有用户提供开放、优质的精品内容发现服务。未来可能推出的增值服务会提前公告通知。',
  },
];

export const aboutInfo = {
  brand: {
    title: '亚洲精品一区二区',
    subtitle: '精选内容分区导览平台',
    intro: '亚洲精品一区二区诞生于2024年，致力于打造亚洲地区最专业的精品内容聚合与分区导览平台。我们以"精准分类、快速定位、优质聚合"为核心理念，通过一区精品推荐与二区优质资源两大核心板块，为用户提供高效、便捷的内容发现体验。',
    mission: '汇聚亚洲优质内容，让每一位用户都能轻松发现感兴趣的精品资源。',
    vision: '成为亚洲地区最受信赖的精品内容导航平台。',
    values: ['品质优先', '用户至上', '持续创新', '开放共享'],
  },
  reputation: {
    title: '用户口碑',
    items: [
      {
        name: '张先生',
        role: '资深内容创作者',
        comment: '亚洲精品一区二区的内容分类体系非常清晰，帮我节省了大量搜索和筛选的时间。一区和二区的划分很有特色，内容质量也很高。',
        rating: 5,
        date: '2025-03-01',
      },
      {
        name: '李女士',
        role: '文化研究者',
        comment: '作为一名文化研究者，我非常欣赏平台对内容品质的严格把控。编辑精选的内容确实都是精品，深度好文板块对我的研究工作帮助很大。',
        rating: 5,
        date: '2025-02-25',
      },
      {
        name: '王同学',
        role: '大学生',
        comment: '使用亚洲精品一区二区快半年了，最喜欢二区的资源聚合功能，能找到很多课堂上接触不到的有趣内容。推荐给了很多同学使用。',
        rating: 5,
        date: '2025-03-05',
      },
      {
        name: '赵女士',
        role: '自媒体运营',
        comment: '平台的内容更新速度很快，分类也很精准。排行榜功能让我能快速了解最近的热门趋势，对内容选题很有参考价值。',
        rating: 4,
        date: '2025-02-28',
      },
      {
        name: '陈先生',
        role: '互联网从业者',
        comment: '专题策划板块做得很用心，每次都能看到有深度、有观点的内容。希望能继续保持这种高品质的内容输出。',
        rating: 5,
        date: '2025-03-10',
      },
    ],
  },
  contact: {
    title: '联系我们',
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    email: 'contact@yazhoujingpin.com',
    phone: '400-888-9999',
    wechat: 'yazhoujingpin',
  },
};